import { safeJson } from "@/lib/http";
import { supabase } from "@/lib/supabase";

const BASE = process.env.REACT_APP_BACKEND_URL;

async function call(path, method = "GET", body) {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) throw new Error("Session expirée, reconnectez-vous.");
    const r = await fetch(`${BASE}${path}`, { method, headers: { Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) }, body: body ? JSON.stringify(body) : undefined });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export const startPeriodeObsJob = (id, payload) => call(`/api/ia/dossiers/${id}/periode-observation/jobs`, "POST", payload || {});
export const fetchPeriodeObsJob = (id, jobId) => call(`/api/ia/dossiers/${id}/periode-observation/jobs/${jobId}`);
export const fetchPeriodeObsReports = (id) => call(`/api/ia/dossiers/${id}/periode-observation`);
export const deletePeriodeObsReport = (id, sessionId) => call(`/api/ia/dossiers/${id}/periode-observation/${sessionId}`, "DELETE");

export async function downloadPeriodeObsPdf(id, sessionId) {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) throw new Error("Session expirée, reconnectez-vous.");
    const r = await fetch(`${BASE}/api/ia/dossiers/${id}/periode-observation/${sessionId}/pdf`, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) { const j = await safeJson(r); throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`); }
    const blob = await r.blob();
    const name = (r.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/)?.[1] || "Periode_Observation.pdf";
    const url = URL.createObjectURL(blob);
    const a = Object.assign(document.createElement("a"), { href: url, download: name });
    a.click();
    URL.revokeObjectURL(url);
}
